export const treatVersioning = (versionNumber) => {
    if(versionNumber.includes(".")) {
        let s = versionNumber.split(".");
        if(s.length >= 3) {
            s.splice(-1);
        }
        const version = s.join(".");
        return version;
    }
};